import { Entity } from '@backstage/catalog-model';

export const convertEntityToProject = (entity: Entity) => {
  return {
    projectName: entity?.spec?.projectName,
    description: entity.metadata.description,
    owner: `group:default/${entity?.spec?.owner}`,
    securityGroups: entity?.spec?.securityGroups,
    // Projects created before the GitHub-only field was generalised still carry
    // spec.githubActionsSubjects, so edit mode must fall back to the old key.
    cicdOidcSubjects:
      entity?.spec?.cicdOidcSubjects ??
      entity?.spec?.githubActionsSubjects ??
      [],
    clusters: entity?.spec?.clustersRawData,
    notificationChannel: entity?.spec?.notificationChannel || '',
    notificationServices: entity?.spec?.notificationServices,
  };
};
